export default "__VITE_ASSET__BNwP$TrI__"